// Общие правила отображения изменения цены: B2B-задания (прямая оплата) не имеют платёжных шагов
import { formatRub } from './money';

export const isDirectPayment = (task) => !!(task?.is_b2b || task?.payment_mode === 'direct');

export const fmtRub = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return String(value ?? '');
  return formatRub(n);
};

// Заказчик должен доплатить разницу через платформу (только эскроу-задания)
export const needsSurcharge = (task, pc) =>
  !!pc &&
  pc.status === 'confirmed' &&
  pc.payment_status !== 'paid' &&
  Number(pc.new_price) > Number(pc.old_price) &&
  !isDirectPayment(task);

// Цена согласована и никаких платёжных шагов не требуется (B2B / прямая оплата)
export const isDirectPriceAgreed = (task, pc) =>
  !!pc && pc.status === 'confirmed' && isDirectPayment(task);

// Активное изменение цены, которое БЛОКИРУЕТ новый запрос на изменение цены:
// либо ожидание ответа исполнителя (proposed), либо подтверждённое повышение
// с ещё не оплаченной доплатой. Завершённые изменения (понижение, оплаченная
// доплата, B2B) не блокируют — кнопка «Изменить цену» должна вернуться (Д8).
export const isPriceChangeBlocking = (task, pc) => {
  if (!pc) return false;
  if (pc.status === 'proposed') return true;
  if (needsSurcharge(task, pc)) return true;
  return false;
};
